import { render, staticRenderFns } from "./ErrorOrgNotFound.vue?vue&type=template&id=718b1af8&"
import script from "./ErrorOrgNotFound.vue?vue&type=script&lang=js&"
export * from "./ErrorOrgNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports